import { Icon } from "@iconify/react/dist/iconify.js";
import { HashLink as Link } from "react-router-hash-link";
import scrollToTop from "../components/scroll-to-top";
import BespokeCarousel from "../components/bespoke";

const HomePage = () => {
  return (
    <>
      <div className="homepage-container">
        <div className="home-page-hero">
          <h1>
            Spinning webs that catch
            <br /> all bugs
          </h1>
          <p className="intro">
            We craft lightning-fast websites with clean code, no bugs, and
            eye-catching designs, so your users stick around and enjoy a pixel
            perfect experience.
          </p>
          <img
            className="hero-img"
            src="https://d1cj3qoxnek6r9.cloudfront.net/home/hero1.webp"
            alt=""
          />{" "}
          <div className="last-hero">
            <Link
              to="/intro-form"
              target="_blank"
              onClick={() => {
                scrollToTop();
              }}
            >
              <button className="home-btn">
                Create my dream site
                <Icon icon="hugeicons:tools" className="icon" rotate="90deg" />
              </button>
            </Link>
            <p className="home-stat">
              75% of people decide if they trust your business
              <br /> based on how it looks online. Let's make it count.
            </p>
          </div>
          <img
            src="https://d1cj3qoxnek6r9.cloudfront.net/home/hexagons1.webp"
            alt="hexagons"
            className="home-hex"
          />
        </div>

        <div className="home-sect2" id="home-sect2">
          <div className="text">
            <h2>From initial sketches to scroll-stopping sites</h2>
            <p>
              We’re with you every step of the way; from initial concept and
              custom design to development, launch, and ongoing maintenance.
              Whether you’re starting fresh or need expert advice on an existing
              site, we offer full-service web solutions.
            </p>
          </div>
          <div className="service-opts">
            <div className="opt">
              <h5 className="opt-h5">Design</h5>
              <p className="opt-text">
                Our design service blends beauty and function through thoughtful
                UI (user interface) and UX (user experience) design, so your
                website looks great and feels effortless to use.
              </p>

              <Link
                to="/design"
                onClick={() => {
                  scrollToTop();
                }}
              >
                <button>
                  Design plans
                  <Icon icon="maki:arrow" className="icon" />
                </button>
              </Link>
            </div>
            <div className="opt">
              <h5 className="opt-h5">Develop</h5>
              <p className="opt-text">
                Our development service brings your website to life with clean,
                reliable code—built for speed, performance, and a seamless user
                experience on every device.
              </p>
              <Link
                to="/development"
                onClick={() => {
                  scrollToTop();
                }}
              >
                <button>
                  Development plans
                  <Icon icon="maki:arrow" className="icon" />
                </button>
              </Link>
            </div>
            <div className="opt">
              <h5 className="opt-h5">Host & Maintain</h5>
              <p className="opt-text">
                We offer flexible hosting and maintenance plans tailored to your
                needs; whether you want hands-off support with regular updates
                and security, or just reliable hosting to keep your site
                running smoothly.
              </p>
              <Link
                to="/hosting-maintenance"
                onClick={() => {
                  scrollToTop();
                }}
              >
                <button>
                  Maintenance plans
                  <Icon icon="maki:arrow" className="icon" />
                </button>
              </Link>
            </div>
            <div className="opt">
              <h5 className="opt-h5">Support</h5>
              <p className="opt-text">
                Our web consulting service is here to guide you. Whether you
                need expert advice on improving your current site, planning a
                redesign, or making sure your online presence aligns with
                your business
              </p>
              <Link
                to="/consulting"
                onClick={() => {
                  scrollToTop();
                }}
              >
                <button>
                  Consulting plans
                  <Icon icon="maki:arrow" className="icon" />
                </button>
              </Link>
            </div>
          </div>
          <Link
            to="/services"
            onClick={() => {
              scrollToTop();
            }}
          >
            <button className="explore">
              Explore our services
              <Icon icon="famicons-earth" height="22" width="22" />
            </button>
          </Link>
          {/* explore button still taking up whole width even when i change width */}
        </div>

        <div className="home-sect3">
          <div className="text">
            <h2>Your vision, Taken personally</h2>
            <p>
              At Acrylic Web Studios, we treat every project like it’s our own.
              When you work with us, you can expect premium-quality web
              services. We don’t just meet expectations, we exceed them. We take
              the time to deeply understand your industry, ensuring that every
              design is not only tailored to your audience but pushes creative
              boundaries within your space.
            </p>
            <span>
              Don’t just take our word for it, hear what our clients have to
              say!
            </span>
            <Link
              to="/about"
              onClick={() => {
                scrollToTop();
              }}
            >
              <button className="dbutton">
                Learn more about us
                <Icon icon="maki:arrow" height="22" width="22" />
              </button>
            </Link>
          </div>
          <div className="hexagon-content1">
            <div className="hex-row1">
              <div className="hexagon hp3-hex1">
                <div className="hexagon-content">
                  <p>
                    <span>" </span>They cared about my website’s success as much
                    as I did!<span> "</span>
                  </p>
                </div>
              </div>
              <div className="hexagon  hp3-hex2">
                <div className="hexagon-content">
                  <img
                    alt=""
                    src="https://d1cj3qoxnek6r9.cloudfront.net/home/laptop1.webp"
                  />
                </div>
              </div>
            </div>
            <div className="hex-row2">
              <div className="hexagon hp3-hex3">
                <div className="hexagon-content">
                  <img
                    alt=""
                    src="https://d1cj3qoxnek6r9.cloudfront.net/home/filler11.webp"
                  />
                </div>
              </div>
              <div className="hexagon hp3-hex4">
                <div className="hexagon-content">
                  <div className="hexagon-content">
                    <p>
                      <span>" </span>Our new site is professional,
                      user-friendly, and perfectly matches our business identity
                      <span> "</span>
                    </p>
                  </div>
                </div>
              </div>
              <div className="hexagon hp3-hex5">
                <div className="hexagon-content">
                  <div className="hexagon-content">
                    <p>
                      <span>" </span>Their support and hosting give us peace of
                      mind every single day.<span> "</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="hex-row3">
              <div className="hexagon hp3-hex6">
                <div className="hexagon-content">
                  <p>
                    <span>" </span>They made our website mobile-friendly, and
                    super easy to update.<span> "</span>
                  </p>
                </div>
              </div>
              <div className="hexagon  hp3-hex7">
                <div className="hexagon-content">
                  <img
                    alt=""
                    src="https://d1cj3qoxnek6r9.cloudfront.net/home/filler21.webp"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="hexagon-contentt1">
            <div className="hex-row1">
              <div className="hexagon hp3-hex1">
                <div className="hexagon-content">
                  <p>
                    <span>" </span>They cared about my website’s success as much
                    as I did!<span> "</span>
                  </p>
                </div>
              </div>
            </div>
            <div className="hex-row2">
              <div className="hexagon hp3-hex4">
                <div className="hexagon-content">
                  <div className="hexagon-content">
                    <p>
                      <span>" </span>Our new site is professional,
                      user-friendly, and perfectly matches our business identity
                      <span> "</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="hex-row3">
              <div className="hexagon hp3-hex5">
                <div className="hexagon-content">
                  <div className="hexagon-content">
                    <p>
                      <span>" </span>Their support and hosting give us peace of
                      mind every single day.<span> "</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="hex-row4">
              <div className="hexagon hp3-hex6">
                <div className="hexagon-content">
                  <p>
                    <span>" </span>The team made our website modern,
                    mobile-friendly, and super easy to update.<span> "</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <Link
            className="tlink"
            to="/about"
            onClick={() => {
              scrollToTop();
            }}
          >
            <button className="tbutton">
              Learn more about us
              <Icon icon="maki:arrow" height="22" width="22" />
            </button>
          </Link>
          <img
            className="homeweb"
            alt=""
            src="https://d1cj3qoxnek6r9.cloudfront.net/webs/homeweb1.webp"
          ></img>
        </div>

        <div className="home-sect4">
          <div className="ttext">
            <h2>Bespoke features</h2>
            <p>
              We’re always hard at work crafting the best design systems,
              compoinents and pages for our client. Each website made by us will
              be uniquely designed and developed with your users in mind.
            </p>
          </div>
          <div className="carousel">
            <BespokeCarousel />
          </div>
          <div className="dtext">
            <h2>Bespoke features</h2>
            <p>
              We’re always hard at work crafting the best design systems,
              compoinents and pages for our client. Each website made by us will
              be uniquely designed and developed with your users in mind.
            </p>{" "}
            <Link
              to="/projects"
              onClick={() => {
                scrollToTop();
              }}
            >
              <button className="dbutton">
                See our recent projects
                <Icon icon="maki:arrow" className="icon" />
              </button>
            </Link>
          </div>
          <Link
            to="/projects"
            className="tlink"
            onClick={() => {
              scrollToTop();
            }}
          >
            <button className="tbutton">
              See our recent projects
              <Icon icon="maki:arrow" className="icon" />
            </button>
          </Link>
        </div>
        <div className="home-sect5">
          <div className="text">
            <h2>Let’s build something great together</h2>
            <p>
              Your business deserves more than just a website — it deserves a
              powerful digital presence, built with care.
            </p>
            <span>Ready to get started?</span>
            <Link
              to="/contact"
              onClick={() => {
                scrollToTop();
              }}
              className="dbutton"
            >
              <button>
                Contact us
                <Icon icon="maki:arrow" className="icon" />
              </button>
            </Link>
          </div>
          <div className="hexagon-content2">
            <div className="hex-row1">
              <div className="hexagon hp5-hex1">
                <div className="hexagon-content">
                  <img alt="" />
                </div>
              </div>
              <div className="hexagon  hp5-hex2">
                <div className="hexagon-content">
                  <img alt="" />
                </div>
              </div>
            </div>
            <div className="hex-row2">
              <div className="hexagon hp5-hex3">
                <div className="hexagon-content">
                  <img alt="" />
                </div>
              </div>
            </div>
          </div>{" "}
          <Link
            to="/contact"
            onClick={() => {
              scrollToTop();
            }}
            className="tbutton"
          >
            <button>
              Contact us
              <Icon icon="maki:arrow" className="icon" />
            </button>
          </Link>
        </div>
      </div>
    </>
  );
};

export default HomePage;
